// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__njzUt","title":"ClientInsurance_title__3W5z2","itemText":"ClientInsurance_itemText__1RgYE"};